export const API_SUBMISSION_MODULE_ROUTES = {
  SUBMISSION_MODULES: '/submission-module/:submissionModuleId',
  MODULE_COMMENTS: '/submission-module/:submissionModuleId/comments',
  MODULE_COMMENT: '/submission-module/:submissionModuleId/comments/:commentId',
  MODULE_NUMBERS: '/submission-module/module-numbers',
  REVIEW_MODULES: '/submission-module/review',
  REVISION_MODULES: '/submission-module/revision',
  REVIEW_MODULE: '/submission-module/review/:submissionModuleId',
};
